const Holidays = require("date-holidays");

export function getPublicHolidays(
  countryCode = "DE",
  year = new Date().getFullYear()
) {
  const hd = new Holidays(countryCode);
  const publicHolidays = hd
    .getHolidays(year)
    .filter((h) => h.type === "public")
    .map((h) => new Date(h.date).toLocaleDateString("sv-SE"));

  return publicHolidays;
}

// {
//   minDate: new Date(window.appConfig.configuratorDesiredMinDate),
//   disable: [
//     function(date) {
//       console.log(
//         window.publicHolidays,
//         date.toISOString().split('T')[0],
//         (window.publicHolidays ?? []).includes(date.toLocaleDateString("sv-SE"))
//       );
//       if((window.publicHolidays ?? []).includes(date.toLocaleDateString("sv-SE"))) {
//         return true;
//       }

//       return (date.getDay() === 0 || date.getDay() === 6);
//     }
//   ]
// }
